export const SALES_TEAM_ENTITY_TYPES = [
  'Lead',
  'Opportunity',
  'OrderReviewChecklist',
  'BoqHeader',
  'TradingRentalEstimation',
  'Quotation',
  'ContractReview',
  'SalesOrder',
] as const;

export type SalesTeamEntityType = (typeof SALES_TEAM_ENTITY_TYPES)[number];
